export enum SogDialogButtons {
  YesNo = "YesNo",
  SaveCancel = "SaveCancel",
  Ok = "Ok",
  OkCancel = "OkCancel",
}
